import { render, staticRenderFns } from "./editBenefit.vue?vue&type=template&id=8a7669ea&scoped=true&"
import script from "./editBenefit.vue?vue&type=script&lang=js&"
export * from "./editBenefit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7669ea",
  null
  
)

export default component.exports